export function getDefaultOptions() {
  return {
    defaultNS: 'common',
    resources: {},
    ns: null,
  }
}
